import serviceModule from '../services/index';

export default angular.module('Serveture-Directives', [
  serviceModule.name
]);